module.exports = __webpack_public_path__ + "static/media/Ribombee_gaussian2.8b36db80.png";